import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { PlayerContext } from "../media-player";

export const useVideoPlayerControls = () => {
  const { videoElement, isPlaying, handleTags, togglePlay } =
    useContext(PlayerContext);

  const sliderRef = useRef<any>();

  const [buffer, setBuffer] = useState(0);
  const [bufferFinished, setBufferFinished] = useState(false);

  const handleOnTimeUpdate = useCallback(() => {
    const timeProgress =
      (videoElement.currentTime / videoElement.duration) * 100;

    const progress = +timeProgress.toFixed(1);

    if (sliderRef?.current?.children?.length) {
      sliderRef.current.children[1].style.width = `${progress}%`;
      sliderRef.current.children[2].style.left = `${progress}%`;
    }
  }, [videoElement.currentTime, videoElement.duration]);

  const handleVideoProgress = useCallback(
    (value: number) => {
      videoElement.currentTime = (videoElement.duration / 100) * value;
    },
    [videoElement]
  );

  const handleBuffer = useCallback(() => {
    if (!bufferFinished) {
      if (videoElement.buffered.length === 0) {
        return;
      }
      const bufferedEnd = videoElement.buffered.end(
        videoElement.buffered.length - 1
      );
      const duration = videoElement.duration;

      const bufferedPercentage = (bufferedEnd / duration) * 100;

      if (bufferedPercentage === 100) {
        setBufferFinished(true);
      }
      setBuffer(bufferedPercentage);
    }
  }, [bufferFinished, videoElement.buffered, videoElement.duration]);

  const handleSeekMouseDown = useCallback(() => {
    if (isPlaying) {
      togglePlay();
    }
  }, [isPlaying, togglePlay]);

  const handleSeekMouseUp = useCallback(() => {
    if (!isPlaying) {
      togglePlay();
    }
  }, [isPlaying, togglePlay]);

  const handleManualChange = useCallback(
    (value: number) => {
      handleVideoProgress(value);
      handleOnTimeUpdate();
      handleTags();
    },
    [handleVideoProgress, handleTags, handleOnTimeUpdate]
  );

  useEffect(() => {
    handleOnTimeUpdate();
  }, [isPlaying, handleOnTimeUpdate]);

  return {
    handleOnTimeUpdate,
    handleSeekMouseDown,
    handleSeekMouseUp,
    handleManualChange,
    handleBuffer,
    videoElement,
    buffer,
    sliderRef,
  };
};
